import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface AlertModel {
  title: string;
  message: string;
}

@Component({
    selector: 'alert',
    templateUrl: 'alert.component.html',
    standalone: false
})
export class AlertComponent implements AlertModel {
  public title: string;
  public message: string;
  constructor(public bsModalRef: BsModalRef) {}
  public close() {
    this.bsModalRef.hide();
  }
}
